import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import { useFetchData, usePostApiRequest } from "../../../helpers/api";
import { handleGlobalInputChange } from "../../../helpers/functions";
import InlineSpinner from "../../../components/loading/InlineSpinner";
import LoadingSpinner from "../../../components/loading/LoadingSpinner";
import Cookies from "js-cookie";
// import throttle from 'lodash.throttle';

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerCode = customerData?.Code;
const theKeyId = customerData?.Id ? customerData.Id : null;
const MyStore = () => {
  const colorInputRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState([]);
  const [isLoadingData, setLoadingData] = useState(false);
  const [storeLogoPath, setStoreLogoPath] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({ StoreLogoFile: "", color: "", storeName: "", GSTNo: "", CustomerCode: "" });
  const [errors, setErrors] = useState({ StoreLogoFile: "", storeName: "", color: "" });

  const postApiRequest = usePostApiRequest();
  const handlechange = (e) => {
    handleGlobalInputChange(e, setFormData);
    setErrors({ ...errors, [e.target.name]: "" });
  }

  // category select
  const { data: stockData, isLoading, refetch } = useFetchData(
    "customerstoredetails",
    "/Customer/GetCustomerStoreDetail",
    { CustomerId: Number(theKeyId) }
  );

  useEffect(() => {
    refetch();
  }, []);
  const handleChangeWithPreview = (e) => {
    // handleGlobalInputChange(e, setFormData);
    // if (e.target.type === "file" && e.target.files[0]) {
    //   const imageUrl = URL.createObjectURL(e.target.files[0]);
    //   setImagePreview(imageUrl);

    //   // Clear the logo file error
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     StoreLogoFile: "",
    //   }));
    // }

    const { name, type, files } = e.target;
    console.log("check this ", name, type, files);

    if (type === "file" && files[0]) {
      const file = files[0];
      const imageUrl = URL.createObjectURL(file);

      setFormData((prevData) => ({
        ...prevData, [name]: file,
      }));
      setImagePreview(imageUrl);

      // Clear the logo file error
      setErrors((prevErrors) => ({
        ...prevErrors,
        StoreLogoFile: "",
      }));
    } else {
      handleGlobalInputChange(e, setFormData);
    }
  };

  // validation
  const formValidation = () => {
    const { storeName, StoreLogoFile, color } = formData;
    let hasError = false;
    let newErrors = {
      storeName: "",
      StoreLogoFile: "",
      color: "",
      GSTNo: "",
    };
    if (!storeName.trim()) {
      newErrors.storeName = "Store name is required.";
      hasError = true;
    }
    if (!StoreLogoFile && !storeLogoPath) {
      newErrors.StoreLogoFile = "Logo is required.";
      hasError = true;
    }
    if (!color.trim()) {
      newErrors.color = "Color is required.";
      hasError = true;
    }
    if (hasError) {
      setErrors(newErrors);
      return;
    }
    return !hasError;
  };

  const submitHandler = async () => {
    if (!formValidation()) return;
    setLoadingData(true);

    const payload = {
      customerId: Number(customerData?.Id),
      customerCode: customerCode,
      StoneName: formData.storeName,
      GSTNo: formData.GSTNo,
      StoreLogoFile: formData.StoreLogoFile,
      StoreColor: formData.color,
      Status: 1,
    };

    console.log("payload :", payload);

    const formDataToSend = new FormData();
    for (const key in payload) {
      const value = payload[key];
      if (Array.isArray(value)) {
        formDataToSend.append(key, JSON.stringify(value));
      } else {
        formDataToSend.append(key, value);
      }
    }
    try {
      const response = await postApiRequest({
        url: "/Customer/SaveCustomerStoreDetail",
        method: "POST",
        data: formDataToSend,
      });
      console.log("response >>>> ", response)
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (stockData && stockData.Data) {
      const data = stockData.Data;

      if (data.StoreLogo) {
        let storePath = data.StoreLogo.split("-").pop();
        setStoreLogoPath(storePath);
      }
      if (data.StoreLogo) {
        const imageUrl = stockData.Data.StoreLogoUrl;
        setImagePreview(imageUrl);
      }

      setFormData((prev) => ({
        ...prev,
        StoreLogoFile: data.StoreLogoFile || "",
        storeName: data.StoneName || "",
        color: data.StoreColor || "#ff0000",
        GSTNo: data.GSTNo || ""
      }));

      if (data.Categories) {
        const selectedCats = data.Categories.split(",").map((cat) =>
          cat.trim()
        );
        setSelectedCategory(selectedCats);
      }

      if (data.Collection) {
        const selectedColl = data.Collection.split(",").map((col) =>
          col.trim()
        );
        setSelectedCollection(selectedColl);
      }
    }
  }, [stockData]);

  const openColorPicker = () => {
    if (colorInputRef.current) {
      colorInputRef.current.click();
    }
  };

  return (
    <DashboardLayout pageClass="mystock_page">
      <div className="my-store-page">
        <h5>My Store Config</h5>
      </div>
      {isLoadingData && <LoadingSpinner />}
      {isLoading ? (
        <div className="loading_screen">
          <InlineSpinner />
        </div>
      ) : (
        <div className="myform">
          {/* enter Store input */}
          <div className="input_con">
            <label htmlFor="" className="mb-2">
              Store Name :
            </label>
            <input
              type="text"
              placeholder="Enter Store Name"
              name="storeName"
              value={formData.storeName}
              onChange={handlechange}
              className="enter_store_name"
            />
            <div>
              {errors && (
                <p className="my_store_errormsg">
                  {errors.storeName}
                </p>
              )}
            </div>
          </div>

          <div className="img_path_con">
            <label htmlFor="" className="mb-2">
              Upload Logo :
            </label>
            <label className="custom-file-input">
              {storeLogoPath ? storeLogoPath : "Upload File"}
              <input
                type="file"
                name="StoreLogoFile"
                accept="image/*"
                onChange={handleChangeWithPreview}
              />
            </label>
            {(imagePreview || storeLogoPath) && (
              <img
                src={imagePreview || storeLogoPath}
                alt="Preview"
                className="show_selected_img"
              />
            )}
            <p style={{ margin: imagePreview || storeLogoPath ? "10px 0 0 48px" : "10px 0 0 0px", display: "flex", justifyContent: 'space-between' }}>
              {errors && (
                <p className="my_storelogo_errmsg">
                  {errors.StoreLogoFile}
                </p>
              )}
              Image Size: 200 x 300
            </p>
          </div>
          <div className="my_store_color">
            <label className="mb-2">My Store Color :</label>
            <div
              className="color-picker-container"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
              }}
              onClick={openColorPicker}
            >
              <div
                className="color-box"
                style={{
                  backgroundColor: formData.color,
                  width: "30px",
                  height: "30px",
                  border: "1px solid #ccc",
                }}
              ></div>

              <input
                type="text"
                value={formData.color}
                readOnly
                name="color"
                className="color-code-input"
              />

              <input
                type="color"
                ref={colorInputRef}
                value={formData.color}
                onChange={handlechange}
                name="color"
                style={{
                  opacity: 0,
                  width: "1px",
                  height: "1px",
                  position: "absolute",
                  pointerEvents: "none",
                  marginTop: '35px'
                }}
              />
            </div>
            {errors && (
              <p className="my_store_errormsg">
                {errors.color}
              </p>
            )}
          </div>
          {/* gst ni field */}
          <div>
            <label htmlFor="" className="mb-2">
              GST No :
            </label>
            <input
              type="text"
              placeholder="Enter Gst No"
              name="GSTNo"
              value={formData.GSTNo}
              onChange={handlechange}
              className="enter_store_name"
            />
          </div>
        </div>
      )}
      <div className="store_submit">
        <button className="btn btn-success" onClick={submitHandler}>
          Save
        </button>
      </div>
    </DashboardLayout>
  );
};

export default MyStore;
